import {
  BottomSheet,
  BottomSheetIllustrationContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";

interface VisitLoggedBottomSheetProps {
  modalState: UseModalState;
}

export function VisitLoggedBottomSheet(props: VisitLoggedBottomSheetProps) {
  const { modalState } = props;
  const { case: caseData } = useInHomeVisitModalsDataContext();
  const { data: facility } = useFacilityProfile(
    { workplaceId: caseData?.attributes.workplaceId ?? "" },
    {
      enabled: isDefined(caseData?.attributes.workplaceId),
    }
  );

  const agencyName = facility?.name ?? "The agency";

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" onClick={modalState.closeModal}>
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="shift-booked"
        title="Visit logged"
        description={
          <List disablePadding sx={{ width: "100%" }}>
            <ListItem>
              <ListItemIcon iconType="checkmark" />
              <ListItemText primary="Your visit has been logged" />
            </ListItem>
            <ListItem>
              <ListItemIcon iconType="dot" />
              <ListItemText
                primary={`${agencyName} to review and approve your visit within 48 hours.`}
                secondary="Please contact the agency for an update if your visit has not been approved
                      within 48 hours of logging your visit."
                secondaryTypographyProps={{ sx: { fontStyle: "italic" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon iconType="dot" />
              <ListItemText primary="Payment to be processed after agency verification" />
            </ListItem>
          </List>
        }
      />
    </BottomSheet>
  );
}
